/**
 * 処理後物品目（大分類）
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposed_item_categories`

const search_recycle_disposed_item_category = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 処理後物大分類リスト
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_recycle_disposed_item_category
